// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-recommendations[data-v-659e5252]{overflow:hidden}.desktop[data-v-659e5252]{display:none!important}@media(min-width:512px){.desktop[data-v-659e5252]{display:block!important}}.mobile[data-v-659e5252]{display:block!important;border-radius:8px;width:360px!important;overflow:visible!important;background:transparent!important}@media(min-width:512px){.mobile[data-v-659e5252]{display:none!important}}.custom-slide[data-v-659e5252]{width:360px!important}", ""]);
// Exports
module.exports = exports;
